import { RequireSignedIn } from '@/components/auth/RequireSignedIn'
import { AppLoader } from '@/components/loading/AppLoader'
import { Onboarding } from '@/features/onboarding'
import { createFileRoute } from '@tanstack/react-router'

/**
 * Onboarding route that handles both organization creation and pending approval flows
 */
export const Route = createFileRoute('/onboarding')({
  component: OnboardingRoute,
})

function OnboardingRoute() {
  return (
    <AppLoader>
      <RequireSignedIn>
        <Onboarding />
      </RequireSignedIn>
    </AppLoader>
  )
}
